import $ from 'jquery';

const logoCarousel = () => {
    $('.logos.owl-carousel').owlCarousel({
        loop: true,
        nav: true,
        navText: ['<','>'],
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            },
            985: {
                items: 6
            }
        }
    });
}

export default logoCarousel;
